/** @jsxImportSource @emotion/react */

import { css, CSSObject } from "@emotion/react";

import {
  CREDIT_BEHAVIOUR_COLUMNS,
  CreditBehaviourDataRow
} from "@/Pages/Dashboard/LeftSide/types";
import { generateDesktopTableStyle } from "@/shared";
import MuiTable from "@mui/material/Table";
import MuiTableBody from "@mui/material/TableBody";

import { colors } from "@dotnet/telematics-design-system";

import CreditBehaviourTableRow from "./CreditBehaviourTableRow";
import CreditTableHead from "./CreditTableHead";

interface CreditBehaviourDesktopTableProps {
  columns: CREDIT_BEHAVIOUR_COLUMNS[];
  dataRows: CreditBehaviourDataRow[];
}

const CreditBehaviourDesktopTable = ({
  columns,
  dataRows
}: CreditBehaviourDesktopTableProps) => {
  return (
    <div
      data-testid="credit-behaviour-desktop-table"
      css={css({
        overflowY: "auto",
        scrollbarWidth: "thin",
        border: `1px solid ${colors.gray200}`,
        borderRadius: "8px"
      })}
    >
      <MuiTable
        css={css(
          generateDesktopTableStyle(colors, false, false, true) as CSSObject
        )}
      >
        <CreditTableHead columns={columns} />

        <MuiTableBody data-testid="credit-behaviour-table-body">
          {dataRows.map((dataRow: CreditBehaviourDataRow, index: number) => (
            <CreditBehaviourTableRow
              dataRow={dataRow}
              key={`${dataRow.device}_mapped_row`}
              index={index}
            />
          ))}
        </MuiTableBody>
      </MuiTable>
    </div>
  );
};

export default CreditBehaviourDesktopTable;
